import { EstimateFieldFilter } from 'module/types/filter-field/filter/estimate';
import { format } from 'module/ui/components/molecules/field-filter/criteria/estimate/format';
import { startCase } from 'lodash';
import { FC } from 'react';

export const EstimateFilterToText: FC<
  React.PropsWithChildren<{ filter: EstimateFieldFilter }>
> = ({ filter }) => {
  const {
    field: { fieldLabel },
  } = filter;

  return (
    <span>
      {startCase(fieldLabel)} {format(filter)}
    </span>
  );
};
